module.exports = __webpack_public_path__ + "media/img/favicon/favicon-9eea2434dc771e9e801ec8117025fdfc.ico";